import { CtaSection } from './components/CtaSection';
import { CuratedTopicsSection } from './components/CuratedTopicsSection';
import { FilterableTopics } from './components/FilterableTopics';

export function PageBody() {
	return (
		<>
			<FilterableTopics />
			<CuratedTopicsSection />
			<CtaSection />
		</>
	);
}
